export const energySavingMockData = {
  yesterday: {
    energyKwh: 11813.811186213268,
    specificPowerDeltaRelative: 0.942592983664887,
    savingCo2: 8.352364508652782,
  },
  monthToDate: {
    energyKwh: 23627.622372426536,
    specificPowerDeltaRelative: 0.942592983664887,
    savingValue: 1653.9335660698578,
    savingCurrency: 'USD',
    savingCo2: 16.704729017305564,
  },
  yearToDate: {
    energyKwh: 528131.3867035876,
    specificPowerDeltaRelative: 0.4990210756905816,
    savingValue: 36969.19706925114,
    savingCurrency: 'USD',
    savingCo2: 373.3888903994363,
  },
  lifetime: {
    energyKwh: 1246459.3327806357,
    specificPowerDeltaRelative: 0.35276911000749345,
    savingValue: 87252.15329464451,
    savingCurrency: 'USD',
    savingCo2: 881.2467482759092,
  },
};
